import * as React from 'react';
import * as main from "../../main.module.scss";
import * as quest from "./style.module.scss";
export const Questions = () => {
  return (
    <section className={quest.quest}>
      <div className={`container ${quest.container}`}>
        <div className={quest.block}>
          <h2 className={main.title}>На вебинаре мы дадим <br/> ответы  на  вопросы: </h2>
          <ul>
            <li>
              <div className={quest.pseudo}>
                <div className={quest.pseudoTriangle}></div>
              </div>
              <p>как привить ребёнку любовь к чтению?</p>
            </li>
            <li>
              <div className={quest.pseudo}>
                <div className={quest.pseudoTriangle}></div>
              </div>
              <p>как повысить мотивацию?</p>
            </li>
            <li>
              <div className={quest.pseudo}>
                <div className={quest.pseudoTriangle}></div>
              </div>
              <p>как выучить таблицу умножения?</p>
            </li>
            <li>
              <div className={quest.pseudo}>
                <div className={quest.pseudoTriangle}></div>
              </div>
              <p>как убрать пробелы в знаниях?</p>
            </li>
          </ul>
        </div>
        <img src="https://fs.advance.ru/landing-pages/webinar/kak_nauchit_rebenka_chitat/questions.png" alt=""/>
      </div>
    </section>
  );
};
